export const LeftTitle = (props) => {
    return (
        <div className="title-left">
            <p>{props.head}</p>
            <h2>{props.title}</h2>
        </div>
    );
}

export const CenterTitle = (props) => {
    return (
        <div className="title-center">
            {
                props.headStatus ?
                    <p>{props.head}</p>
                    : null
            }
            <h2>{props.title}</h2>
        </div>
    );
}